import { render } from "./NavDot.vue?vue&type=template&id=57d0dc79&scoped=true"
import script from "./NavDot.vue?vue&type=script&lang=js"
export * from "./NavDot.vue?vue&type=script&lang=js"

import "./NavDot.vue?vue&type=style&index=0&id=57d0dc79&lang=scss&scoped=true"

import exportComponent from "/local/p4clients/pkgbuild-const/workspace/src/VendorCentralTrimWebsite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57d0dc79"]])

export default __exports__